export const _getGlobalPermissionForm = (state, action) => action.payload;

export const _setGlobalPermissions = (state, action) => {
  state.permissions = action.payload;
};
